import { useState, useEffect, useCallback, useRef } from 'react';
import { apiFetch, buildQuery } from '../utils/api';

export function useApi(endpoint, params = {}, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasData = useRef(false);

  const reload = useCallback(async () => {
    // Ne passer en loading=true que si aucune donnée n'a encore été chargée
    // (évite de démonter les composants enfants lors d'un rafraîchissement)
    if (!hasData.current) setLoading(true);
    setError(null);
    try {
      const result = await apiFetch(`${endpoint}${buildQuery(params)}`);
      setData(result);
      hasData.current = true;
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, JSON.stringify(params), ...deps]);

  useEffect(() => {
    hasData.current = false;
    setLoading(true);
    reload();
  }, [reload]);

  return { data, loading, error, reload };
}
